"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IERC721Errors__factory = exports.IERC20Errors__factory = exports.IERC1155Errors__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var IERC1155Errors__factory_1 = require("./IERC1155Errors__factory");
Object.defineProperty(exports, "IERC1155Errors__factory", { enumerable: true, get: function () { return IERC1155Errors__factory_1.IERC1155Errors__factory; } });
var IERC20Errors__factory_1 = require("./IERC20Errors__factory");
Object.defineProperty(exports, "IERC20Errors__factory", { enumerable: true, get: function () { return IERC20Errors__factory_1.IERC20Errors__factory; } });
var IERC721Errors__factory_1 = require("./IERC721Errors__factory");
Object.defineProperty(exports, "IERC721Errors__factory", { enumerable: true, get: function () { return IERC721Errors__factory_1.IERC721Errors__factory; } });
